import useIsMobileView from '@/hooks/useIsMobileView';
import { useAccountAbstractionInitialization } from '@/features/account-abstraction/hooks/useAccountAbstractionInitialization';
import { useNavigate } from 'react-router-dom';
import useGetFriendsRequest from '@/services/friends/queries/useGetFriendRequest';
import ROUTES from '@/routers/Routes';
import Header from '@/components/header/Header';
import UserProfileMobile from '@/features/user-profile/components/UserProfileMobile';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import FriendRequestTable from '@/pages/friendsRequest/components/FriendRequestTable';
import UserProfile from '@/features/user-profile/components/UserProfile';
import { IoArrowBackOutline } from 'react-icons/io5';
import React, { useState } from 'react';
import { FriendRequest } from '@/services/friends/friendsServicesTypes';
import { usePatchFriendRequest } from '@/services/friends/queries/usePatchFriendRequest';
import BREAKPOINTS from '@/common/constant/breakpoints';

const FriendsRequest = () => {
  const isMobileView = useIsMobileView({ checkForUserAgent: false, breakpoint: BREAKPOINTS.xl });
  useAccountAbstractionInitialization();
  const navigate = useNavigate();
  const { data: friendsRequestData, isFetching } = useGetFriendsRequest();

  const { mutate } = usePatchFriendRequest();

  const handleAccept = (userId: string) => {
    mutate({ userId, accept: true });
    setLocalData((prevData) => {
      return prevData.filter((request) => request.id !== userId);
    });
  };

  const handleDecline = (userId: string) => {
    mutate({ userId, accept: false });
    setLocalData((prevData) => {
      return prevData.filter((request) => request.id !== userId);
    });
  };

  const onClickGoBackHandler = () => navigate(ROUTES.FRIENDS);

  const [localData, setLocalData] = useState<FriendRequest[]>(friendsRequestData?.data?.received || []);

  return (
    <>
      <div className="">
        <Header />
        {isMobileView && (
          <div className="mx-4">
            <UserProfileMobile />
          </div>
        )}
        <div className="flex h-full w-full gap-5 px-4 pt-2 md:px-10 md:pt-5">
          <div className="flex w-full flex-col gap-4">
            <div className="flex items-center gap-4">
              <IoArrowBackOutline onClick={onClickGoBackHandler} className="h-8 w-8 cursor-pointer text-white" />
              <span className="font-manrope text-2xl font-bold text-white">Friend Requests ({localData.length})</span>
            </div>
            {isFetching ? (
              <LoadingSpinner size={'8'} />
            ) : (
              <>
                {localData.length > 0 && (
                  <FriendRequestTable data={localData} handleAccept={handleAccept} handleDecline={handleDecline} />
                )}

                {friendsRequestData?.data.received.length === 0 && (
                  <div className="flex h-full items-center justify-center py-2">
                    <span className="text-white text-opacity-50">No friends request yet</span>
                  </div>
                )}
              </>
            )}
          </div>
          {!isMobileView && <UserProfile />}
        </div>
      </div>
    </>
  );
};

export default FriendsRequest;
